import React from 'react'
import { Helmet } from "react-helmet";
import "../../styles/SearchMap.css";
import KH_Image from "../../Images/kh_image_2-1.png";
import kleenhub_logo from "../../Images/plain_logo.png";
import { Button, TextField } from '@mui/material';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { LoadingComponent } from '../../components/LoadingComponent';
import { forgotPin, loginUser, registerUser } from '../../Services/Events.services';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
const webSiteUrl = 'https://kleenhub.com';

export const ForgotPin = () => {
    const history = useNavigate();
    const [phoneNumber, setphoneNumber] = React.useState('');
    const [spinnerList, setSpinnerList] = React.useState(false);

    const sendForgotPinRequest = async() => {
        try {
            setSpinnerList(true);
            if (!phoneNumber) {
                swal('Error', 'Phone number is required.', 'error');
            } else {
                const response = await forgotPin(`+${phoneNumber}`);
                if (response.status === 200 || response.status === 201) {
                    swal({  
                        title: "Sent Verification Link",  
                        text: "A verification link has been sent to your registered phone number. Clicking on this link will redirect you to the page where you can reset your PIN.",  
                        icon: "success",  
                        button: "Ok",  
                      });
                }
            }
            setSpinnerList(false);
        } catch (err) {
            setSpinnerList(false)
            swal('Error', err.response.data.message, 'error');
        }
    }

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        document.title = 'kleen hub - Forget PIN';  
    }, []);

    const redirectToLogin = () => {
        history(`/login`);
    }

    const ForgetPinPage = () => {
        return (
            <LoadingComponent loader={spinnerList}>
                <div style={{ maxWidth: '420px', position: 'absolute',
                top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                    <a className='title' style={{ maxWidth: '420px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                        <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                    </a>
                    <div className="img1" style={{ position: 'relative', top: '-100px' }} id="first-page">
                        <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={KH_Image}/>
                        <div className='div-text'>
                            <div id="oval_parent" className="multi-ellipse" style={{ top: '-160px', display: 'block' }}>
                                <div id="oval"></div>
                            </div>
                            <div className="vertical-center" style={{ display: 'block', top: '130px' }}>
                                <p className='text-content-left' style={{ padding: '0px' }}>
                                    Welcome to kleenhub.
                                </p>
                                <PhoneInput
                                    country={"dk"}
                                    enableSearch={true}
                                    value={phoneNumber}
                                    onChange={(phone) => setphoneNumber(phone)}
                                    />
                                <a href="#" onClick={() => redirectToLogin()} style={{ color: '#538103', textDecoration: 'underline', display: 'block', textAlign: 'center', margin:'5px'  }}>
                                    <strong>
                                    Redirect to Login
                                    </strong>
                                </a>
                                <Button variant="outlined"
                                    style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '25%', top: '25px', lineHeight: '1', width: "160px", height: "68px",
                                    fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                    textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                    disableRipple={true}
                                    onClick={sendForgotPinRequest}
                                    >
                                        Send Verification Link
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </LoadingComponent>
        )
    }

    return (
        <div>
            <Helmet>
                <title>kleenhub</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {
                ForgetPinPage()
            }
        </div>
    )
}
